import React from 'react';
import classnames from 'classnames';

import { Button } from 'ub/components/button';
import { itemsPropType } from './prop-types';

import styles from './delete-confirmation.scss';

export default class DeleteConfirmation extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
  }

  handleCancelDelete() {
    this.props.dispatch({ type: 'cancelDelete' });
  }

  handleConfirmDelete() {
    this.props.dispatch({ type: 'confirmDelete' });
  }

  render() {
    const { items } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={classnames('svg-ico-warning4', styles.icon)} />

        <p>
          Are you sure you want to delete
          {items.length > 1 ? ` these ${items.length} assets` : ' this asset'}?
        </p>

        <ul className={styles.fileList}>
          {items.map(item => <li key={item.id}>{item.asset.content_file_name}</li>)}
        </ul>

        <div>
          <Button clickAction={this.handleCancelDelete} size="small" type="secondary">
            Cancel
          </Button>

          <Button clickAction={this.handleConfirmDelete} size="small" type="warn">
            Yes, Delete
          </Button>
        </div>

        <p>Caution: This cannot be undone.</p>
      </div>
    );
  }
}

DeleteConfirmation.propTypes = {
  items: itemsPropType.isRequired,
  dispatch: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/delete-confirmation.jsx